<template>
  <div class="order-list-page">
    <div class="container page">
      <h1>訂單</h1>
      <fieldset class="text-right">
        <legend>篩選</legend>備妥:
        <input
          class="align-middle"
          type="checkbox"
          v-model="filter.status.ready"
          :true-value="true"
          :false-value="false"
        />
        配送:
        <input
          class="align-middle"
          type="checkbox"
          v-model="filter.status.sending"
          :true-value="true"
          :false-value="false"
        />
        付款:
        <input
          class="align-middle"
          type="checkbox"
          v-model="filter.status.complete"
          :true-value="true"
          :false-value="false"
        />
      </fieldset>
      <hr />
      <div v-for="(order, index) in orders" :key="index">
        <fieldset
          :disabled="inProgress"
          v-if="(order.status.valify
          && filter.status.ready == order.status.ready)
          && (filter.status.sending == order.status.sending)
          && (filter.status.complete == order.status.complete)"
        >
          <label>{{order.orderId}}</label>
          <table class="table">
            <thead>
              <tr>
                <th class="text-left">餐點名稱</th>
                <th>價格</th>
                <th>數量</th>
                <th>小計</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(meal, index) in order.orderMeals" :key="index">
                <td class="text-left">{{meal.name}}</td>
                <td>{{meal.price}}</td>
                <td>{{meal.quantity}}</td>
                <td>{{meal.quantity*meal.price}}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th class="text-left">總額:</th>
                <td></td>
                <td></td>
                <td>{{order.amount}}</td>
              </tr>
              <tr>
                <th class="text-left">狀態:</th>
                <td v-if="order.status.ready">
                  備餐
                  <input
                    class="align-middle"
                    type="checkbox"
                    :disabled="currentUser.account != order.merchantId"
                    @click="orderStatusReadySwitch(order)"
                    v-model="order.status.ready"
                    :true-value="true"
                    :false-value="false"
                  />
                </td>
                <td v-else>
                  <button
                    class="btn btn-sm btn-secondary"
                    type="button"
                    :disabled="currentUser.account != order.merchantId"
                    @click="orderStatusReadySwitch(order)"
                  >備餐</button>
                </td>
                <td v-if="order.status.sending || !currentUser.group.deliveryman">
                  遞送
                  <input
                    :disabled="!currentUser.group.deliveryman"
                    class="align-middle"
                    type="checkbox"
                    @click="orderStatusSendingSwitch(order)"
                    v-model="order.status.sending"
                    :true-value="true"
                    :false-value="false"
                  />
                </td>
                <td v-else>
                  <button
                    class="btn btn-sm btn-secondary"
                    type="button"
                    :disabled="!currentUser.group.deliveryman"
                    @click="orderStatusSendingSwitch(order)"
                  >遞送</button>
                </td>
                <td>
                  付款
                  <input
                    type="checkbox"
                    disabled
                    v-model="order.status.complete"
                    :true-value="true"
                    :false-value="false"
                  />
                </td>
              </tr>
            </tfoot>
          </table>
        </fieldset>
      </div>
    </div>
    <div v-if="showQrcode">
      <qrcode-vue :value="completeUrl+'/'+currentUser.account" :size="300" level="H"></qrcode-vue>請向配送員示出QRcode
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import QrcodeVue from "qrcode.vue";
export default {
  name: "OrderList",
  async beforeRouteEnter(to, from, next) {
    await store.dispatch("fetchOrders", to.params.slug);
    return next();
  },
  async beforeRouteUpdate(to, from, next) {
    await store.dispatch("fetchOrders", to.params.slug);
    return next();
  },
  mounted() {},
  computed: {
    completeUrl() {
      return (
        window.location.origin +
        "/" +
        this.$router.resolve({ name: "orders" }).href
      );
    },
    showQrcode: function() {
      if (
        this.filter.status.ready ||
        this.filter.status.sending ||
        this.filter.status.complete
      ) {
        return false;
      }
      let count = 0;
      for (let index in this.orders) {
        if (this.orders[index].status.ready == this.filter.status.ready) {
          count++;
        }
      }
      return count == 0;
    },
    ...mapGetters(["orders", "currentUser"])
  },
  methods: {
    orderStatusReadySwitch(order) {
      order.status.ready = !order.status.ready;
      this.$store.dispatch("orderSetStatus", order);
    },
    orderStatusSendingSwitch(order) {
      if (!order.status.ready) {
        return false;
      }
      order.status.sending = !order.status.sending;
      this.$store.dispatch("orderSetStatus", order);
    }
  },
  data() {
    return {
      inProgress: false,
      errors: {},
      filter: {
        status: { ready: false, sending: false, complete: false }
      },
      count: 0
    };
  },
  watch: {},
  components: {
    QrcodeVue
  }
};
</script>
